module.exports = __webpack_public_path__ + "static/media/login-black-36dp.e71c1c0e.svg";